import { DomSelector } from "./dom-selector";

export class E2eDomSelector {

	private selector: DomSelector;

	constructor() {
		this.selector = new DomSelector((elem) => this.getElement(elem));
	}

	public async selectAsync(): Promise<any> {
		let prevTitle = document.title;
		let element = await this.selector.runAsync();
		document.title = prevTitle;
		return element && this.getSelector(element);
	}

	private getElement(elem: Element): Element {
		while (elem) {
			let currSelector = this.getElementSelector(elem);
			if (Object.keys(currSelector).length !== 0) {
				document.title = JSON.stringify(currSelector);
				return elem;
			}

			elem = elem.parentElement;
		}
		return elem;
	}

	private getElementSelector(element: Element): any {

		let selector: any = {};

		let id = element.getAttribute("id");
		if (id) {
			selector.css = "#" + id;
		}

		let dataBind = element.getAttribute("data-bind");
		if (dataBind) {
			let parts = dataBind.replace(/\s+/g, " ").split(",");
			for (let item of parts) {
				let match = /^\s?([a-zA-Z]+)\s?:\s?([^'"]+)\s?$/g.exec(item);
				if (match) {
					let widget = match[1];
					let value = match[2];

					if (!widget.startsWith("dx") && widget !== "with" && widget !== "click") {
						continue;
					}

					if (widget.startsWith("dxValidat")) {
						continue;
					}

					selector[widget] = value;
				}
			}

		}

		return selector;
	}

	private getSelector(element: Element): any[] {

		let selector: any[] = [];
		let hasId = false;

		while (element) {

			let currSelector = this.getElementSelector(element);
			if (hasId) {
				delete currSelector.css;
			} else {
				hasId = currSelector.css && currSelector.css.startsWith("#");
			}

			if (Object.keys(currSelector).length !== 0) {
				selector.unshift(currSelector);
			}

			element = element.parentElement;
		}

		return selector;

	}
}
